/**
 * Generates a random integer between min and max
 * @param min minium integer value to generate
 * @param max maxium integer value to generate
 * @returns {number} a random integer between min and max
 */
export var getRandomInt = function (min, max) {
    var minC = Math.ceil(min);
    var maxF = Math.floor(max);
    return Math.floor(Math.random() * (maxF - minC + 1)) + minC;
};
//# sourceMappingURL=getRandomInt.js.map